/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import Vue from 'vue';

var RenderComponent = Vue.extend({
  name: "render-component",
  functional: true,
  props: {
    render: Function
  },
  render: function render(h, ctx) {
    return ctx.props.render(h, ctx.data.attrs);
  }
});

export { RenderComponent as default };
//# sourceMappingURL=render-component.js.map
